export default "__VITE_ASSET__Dn46xiPP__"